import type { DocsService } from '@affine/core/modules/doc';
import { Service } from '@toeverything/infra';
import { map, type Observable } from 'rxjs';

import type { FilterProvider } from '../../provider';
import type { FilterParams } from '../../types';
import type { WorkspacePermissionService } from '@affine/core/modules/permissions';

export class CanViewFilterProvider extends Service implements FilterProvider {
  constructor(private readonly docsService: DocsService, private readonly workspacePermissionService: WorkspacePermissionService) {
    super();
  }


  filter$(params: FilterParams): Observable<Set<string>> {
    const method = params.method;
    const isAdmin = this.workspacePermissionService.permission.isAdmin$.value;
    const isOwner = this.workspacePermissionService.permission.isOwner$.value;
    const docsPermission = this.workspacePermissionService.docsPermission.permissions$.value;


    if (method === 'view') {
      // const userIds = params.value?.split(',').filter(Boolean) ?? [];

      console.debug('CanViewFilterProvider', method, params, isAdmin, docsPermission);
      return this.docsService.propertyValues$('createdBy').pipe(
        map(o => {
          const match = new Set<string>();
          for (const [id, value] of o) {
            if (isAdmin || isOwner) {
              match.add(id);
              continue;
            }

            const docRole = docsPermission?.find(
              permission => permission.id === id
            )?.role;

            if (docRole && +docRole > 0) {
              match.add(id);
            }

          }
          return match;
        })
      );
    }
    throw new Error(`Unsupported method: ${params.method}`);
  }
}
